import { GET_MONITOR_STABILITY, GET_MONITOR_ENABLED } from "./actions.type";

import { SET_MONITOR_STABILITY, SET_MONITOR_ENABLED } from "./mutations.type";

import {
  getStabilityByGeohash,
  getStabilityByCountry,
  getStabilityByCity,
  getStabilityByCounty,
} from "@/services/grids/stability.service";
import { GRIDS_STABILITY_TYPES } from "@/common/constants/grids";

const STATE = {
  enabled: false,
  stability: {
    feature: null,
    forecast: null,
    metadata: null,
    Item: null,
  },
};

const GETTERS = {
  enabled: (state) => state.enabled,
  stability: (state) => state.stability,
};

const ACTIONS = {
  [GET_MONITOR_ENABLED](context, params) {
    context.commit(SET_MONITOR_ENABLED, params);
  },
  async [GET_MONITOR_STABILITY](context, params) {
    try {
      let result;
      params.omitGeometry = true;
      if (params.stabilityType === GRIDS_STABILITY_TYPES.country) {
        result = await getStabilityByCountry(params);
      } else if (params.stabilityType === GRIDS_STABILITY_TYPES.region) {
        result = await getStabilityByGeohash(params);
      } else if (params.stabilityType === GRIDS_STABILITY_TYPES.city) {
        result = await getStabilityByCity(params);
      } else if (params.stabilityType === GRIDS_STABILITY_TYPES.county) {
        result = await getStabilityByCounty(params);
      }

      context.commit(SET_MONITOR_STABILITY, result);
    } catch (error) {
      console.error("Error in GET_MONITOR_STABILITY actions: " + error);
    }
  },
};

const MUTATIONS = {
  [SET_MONITOR_ENABLED](state, data) {
    state.enabled = data;
  },
  [SET_MONITOR_STABILITY](state, data) {
    state.stability = data || false;
  },
};

export default {
  namespaced: true,
  state: STATE,
  actions: ACTIONS,
  mutations: MUTATIONS,
  getters: GETTERS,
};
